import CopyBtn from "@/components/copy-btn";
import { ReturnRequestDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { Badge } from "@babackapp/ui/components/badge";
import { PersonIcon } from "@radix-ui/react-icons";

interface CustomerInfoProps {
  returnRequest: ReturnRequestDto;
}

export default function CustomerInfo({
  returnRequest: { customer },
}: CustomerInfoProps) {
  const t = useTranslation();
  const name = `${customer.first_name} ${customer.last_name}`;

  return (
    <div>
      <h2 className="text-sm mb-2 inline-flex items-center gap-2">
        <PersonIcon className="size-3" />
        {t("misc.customer")}
      </h2>
      <div className={"flex flex-col gap-1 text-sm"}>
        <CopyBtn value={name}>
          <span>{name}</span>
        </CopyBtn>
        <CopyBtn value={customer.email}>
          <span>{customer.email}</span>
        </CopyBtn>
        <CopyBtn value={customer.phone}>
          <span>{customer.phone}</span>
        </CopyBtn>
        {customer.customerSegment?.name && (
          <div className="flex flex-col gap-1">
            <span className={"text-xs text-muted-foreground"}>Segment</span>
            <div className="flex items-center justify-between gap-1">
              <div>{customer.customerSegment?.name}</div>
          </div>
          <div className={"flex flex-1 flex-row gap-1"}>
            {!!customer.customerSegment?.hasFreeReturn && (
              <Badge variant={"secondary"}>
                {t("returnDetail.rightBar.customerInfo.hasFreeReturn")}
              </Badge>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
